$.fn.Characters = function() {
	/* Instance */
	let self = this
	if (self.data('instance')) {
		return self;
	}
	self.data('instance', self)
	self.state = $('<span class="characters"></span>')
  self.maxlength = parseInt(self.attr('maxlength'), 10)

	self.i18n = window.gourmetsauvage_params || {}

	self.update = function() {
    let remaining = self.maxlength - self.val().length;
    if (remaining === 0) {
      self.state.html(self.i18n.CHARS_LIMIT || 'Limite de caractères atteinte')
      return
    }
    let template = remaining === 1
      ? (self.i18n.CHARS_ONE || '%d caractère restant')
      : (self.i18n.CHARS_MANY || '%d caractères restants')
    self.state.html(template.replace('%d', '<strong>' + remaining + '</strong>'))
	}

	return function() {
    if (!self.maxlength) {
      self.maxlength = 160
    }
		self.on('keyup keydown keypress change focus blur', self.update)
		self.update()
		self.after(self.state)
		return self
	}()
}
